var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiamondsSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 88,
    viewBox: "0 0 184 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "diamonds_subscription-a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 16,
    width: 59,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.439 40.342 128.266 70.35c-.369.324-.554.486-.749.522a.722.722 0 0 1-.497-.088c-.17-.1-.288-.316-.524-.747l-21.849-39.886c-.148-.271-.222-.407-.239-.546a.734.734 0 0 1 .051-.362c.055-.13.163-.239.381-.458l8.464-8.523c.057-.057.086-.086.117-.11a.715.715 0 0 1 .087-.061c.035-.02.072-.037.145-.07l7.837-3.488c.074-.033.111-.05.149-.062a.72.72 0 0 1 .104-.024c.04-.007.08-.009.161-.012l7.33-.342a1.489 1.489 0 0 1 .127 0l.076.008 7.314.954 7.199 1.605a1.814 1.814 0 0 1 .122.033l.071.029 6.771 2.828c.074.031.112.047.147.066a.703.703 0 0 1 .089.06c.032.024.062.052.12.108l6.17 5.958h.001c.057.056.086.084.112.115a.646.646 0 0 1 .061.087c.021.034.038.07.072.144l5.039 10.904c.129.28.194.42.201.56a.715.715 0 0 1-.076.358c-.063.125-.179.227-.411.43Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#diamonds_subscription-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.642 15.153 102.736 2.65 90.234 73.556 161.14 86.06l12.502-70.906Z",
    fill: "#7EC7FF",
    style: {
      mixBlendMode: "hue"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m113.402 12.598 46.815 8.254L158 33.422l-46.814-8.256 2.216-12.568Z",
    fill: "#7EC7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m134.593 29.294 7.555 11.904-18.725-3.302 11.17-8.602Z",
    fill: "#75C1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m115.389 22.838-11.156 6.559 8.315 3.683 2.841-10.242Z",
    fill: "#7AC6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.348 26.981 112.55 33.08l10.873 4.816 1.925-10.915ZM144.072 30.283l9.941 10.108-11.865.807 1.924-10.915Z",
    fill: "#8FCEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m112.55 33.08 12.798-6.099-9.958-4.143-2.84 10.242ZM154.012 40.391l-9.94-10.108 10.774-.488-.834 10.596Z",
    fill: "#47A9F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m154.848 29.796 8.239 9.978-9.073.617.834-10.595Z",
    fill: "#7AC6FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m113.456 20.11-9.223 9.287 11.156-6.559-1.933-2.728ZM157.596 27.893l5.491 11.881-8.239-9.978 2.748-1.903ZM163.086 39.774 127.187 71.3l14.961-30.101 20.938-1.424ZM104.234 29.397l22.953 41.902-3.764-33.403-19.189-8.499Z",
    fill: "#47A9F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m104.234 29.397 21.281 41.607-12.966-37.924-8.315-3.683ZM163.086 39.774l-34.227 31.82 25.154-31.203 9.073-.617Z",
    fill: "#309FF1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m123.424 37.896 2.947 38.033 15.779-34.731-18.726-3.302Z",
    fill: "#8DCCFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m132.787 39.547-8.145 14.081-1.218-15.732 9.363 1.65Z",
    fill: "#BFE2F7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m132.785 39.547 2.837 16.017 6.526-14.366-9.363-1.651Z",
    fill: "#BFE2F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m123.423 37.896 1.925-10.915 9.246 2.313-11.171 8.602ZM142.149 41.198l1.925-10.915-9.48-.99 7.555 11.905Z",
    fill: "#99D1FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m129.008 33.595 5.586-4.301-9.246-2.313 3.66 6.614ZM138.372 35.246l-3.778-5.952 9.48.989-5.702 4.963Z",
    fill: "#ADDCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "diamonds_subscription-b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 16,
    width: 59,
    height: 55
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.352 30.152 57.504 70.038c-.236.431-.355.647-.525.747a.72.72 0 0 1-.497.088c-.195-.036-.38-.198-.749-.522L21.56 40.34c-.232-.203-.348-.305-.41-.43a.719.719 0 0 1-.076-.358c.006-.14.071-.28.2-.56l5.04-10.904c.033-.073.05-.11.07-.144a.722.722 0 0 1 .063-.087c.025-.03.054-.059.112-.115l6.17-5.958c.059-.056.088-.084.12-.109a.735.735 0 0 1 .09-.059c.035-.02.072-.035.147-.066l6.77-2.828a1.447 1.447 0 0 1 .12-.044l.074-.018 7.199-1.605 7.314-.954c.037-.004.056-.007.075-.008a.712.712 0 0 1 .051-.003l.076.003 7.33.342c.081.004.122.006.161.012.035.005.07.014.104.024.039.013.076.03.15.062l7.836 3.488c.074.033.11.05.145.07a.69.69 0 0 1 .088.06c.03.025.06.054.116.111l8.464 8.523c.218.22.327.329.38.458a.718.718 0 0 1 .052.362c-.016.14-.09.275-.239.546Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#diamonds_subscription-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.264 2.65 10.357 15.153 22.86 86.059l70.906-12.503L81.264 2.65Z",
    fill: "#7EC7FF",
    style: {
      mixBlendMode: "hue"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m23.783 20.852 46.814-8.254 2.217 12.568-46.815 8.255-2.216-12.569Z",
    fill: "#7EC7FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m49.406 29.294 11.17 8.602-18.725 3.302 7.555-11.904Z",
    fill: "#75C1FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m29.152 29.796-8.239 9.978 9.073.617-.834-10.595Z",
    fill: "#7AC6FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m39.926 30.283-9.94 10.108 11.864.807-1.924-10.915ZM58.652 26.981 71.45 33.08l-10.873 4.816-1.925-10.915Z",
    fill: "#8FCEFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m29.985 40.391 9.94-10.108-10.773-.488.833 10.596ZM71.45 33.08l-12.798-6.099 9.958-4.143 2.84 10.242Z",
    fill: "#47A9F1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m68.61 22.838 11.154 6.56-8.315 3.682-2.84-10.242Z",
    fill: "#7AC6FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m26.403 27.893-5.49 11.882 8.24-9.979-2.75-1.902ZM70.542 20.11l9.223 9.287-11.156-6.559 1.933-2.728ZM79.766 29.397 56.813 71.3l3.764-33.403 19.189-8.499Z",
    fill: "#47A9F1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m20.914 39.774 35.9 31.525-14.962-30.101-20.938-1.424Z",
    fill: "#47A9F1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m20.914 39.774 34.228 31.82L29.987 40.39l-9.073-.617ZM79.766 29.397l-21.28 41.607L71.45 33.08l8.315-3.683Z",
    fill: "#309FF1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.852 41.198 57.63 75.93l2.947-38.034-18.725 3.302Z",
    fill: "#8DCCFC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m51.214 39.547-2.837 16.018-6.525-14.367 9.362-1.65ZM51.215 39.547l8.144 14.081 1.219-15.732-9.363 1.65Z",
    fill: "#BFE2F7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m41.85 41.198-1.924-10.915 9.48-.99-7.556 11.905ZM60.576 37.896l-1.924-10.915-9.246 2.313 11.17 8.602Z",
    fill: "#99D1FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m45.628 35.246 3.777-5.952-9.48.99 5.703 4.962ZM54.991 33.595l-5.585-4.301 9.246-2.313-3.66 6.614Z",
    fill: "#ADDCFF"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M56 44C56 24.118 72.118 8 92 8s36 16.118 36 36-16.118 36-36 36-36-16.118-36-36Z",
    fill: "url(#diamonds_subscription-c)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.515 31.656C89.468 27.7 90.445 25.72 92 25.72c1.554 0 2.53 1.979 4.484 5.936l.65 1.319c.57 1.154.855 1.732 1.354 2.094.5.363 1.137.456 2.411.64l1.455.212c4.367.635 6.551.952 7.031 2.43.48 1.478-1.1 3.018-4.26 6.099l-1.053 1.026c-.922.899-1.383 1.348-1.574 1.935-.19.587-.081 1.221.136 2.49l.249 1.45c.746 4.35 1.119 6.524-.138 7.438-1.258.913-3.21-.114-7.117-2.167l-1.301-.685c-1.14-.599-1.71-.898-2.327-.898s-1.187.3-2.327.898l-1.301.685c-3.906 2.053-5.86 3.08-7.117 2.166-1.257-.913-.884-3.088-.138-7.437l.249-1.45c.218-1.269.326-1.903.136-2.49-.191-.587-.652-1.036-1.574-1.935l-1.053-1.026c-3.16-3.08-4.74-4.62-4.26-6.099.48-1.478 2.664-1.795 7.031-2.43l1.455-.211c1.274-.185 1.911-.278 2.41-.64.5-.363.785-.94 1.355-2.095l.65-1.319Z",
    fill: "#FAFAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "diamonds_subscription-c",
    x1: 56,
    y1: 8,
    x2: 128,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA61F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6950E6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondsSubscription);
export default __webpack_public_path__ + "static/media/diamonds_subscription.5258304c.svg";
export { ForwardRef as ReactComponent };